import FeaturedSolutions from "../../components/FeaturedSolutions";
import LogoMini from "../../components/icons/LogoMini";
import IGFly from "../../assets/img/Featured/fly-tap-pay.png";
import OnDemand from "../../assets/img/Featured/app-ondemand-food.png";
import QuickPay from "../../assets/img/Featured/app-qr-quickpay-tall.png";
import Reserve from "../../assets/img/Featured/app-tennis.png";
import Book4Time from "../../assets/img/Featured/app-book4time-tennis.png";
import "./index.scss";
import { useNavigate } from "react-router-dom";
import { useAnalytics } from "@popped/popshap-kiosk-components";
import { useCallback } from "react";
import { useData } from "../../context/DataProvider";
import { Header } from "../../components/Header";
const TennisPage = () => {
    const { logEvent } = useAnalytics();
    const { addFlow, location } = useData()!;
    const _logEvent = useCallback(async (type: string, value: string, id?: string) => {
        await logEvent(type, value, { kiosk: location, id: id })
    }, [logEvent,location])
    const navigate = useNavigate();
    return(
        <div className="page splash tennisPage">
            <div className="background" />
            <Header />
            <div className="page-header">Tennis Court</div>
            <div className="text-blocks">
                <div className="std-text">
                    Serve up a winning player experience. Whether
                    it's booking a court time, scheduling a lesson or
                    providing courtside refreshments, you need a
                    flexible, configurable solution that seamlessly
                    integrates with PMS and POS solutions as well as
                    adds court reservations to a common
                    guest itinerary.
                </div>
            </div>
            <FeaturedSolutions>
                <div className="featured-item" onClick={()=>{
                    _logEvent('click', "Tennis", "IG Fly");
                    addFlow("IG Fly");
                    navigate("/solutions/ig-fly")}}>
                    <div className="item-head">
                        <LogoMini />
                        IG Fly
                    </div>
                    <img src={IGFly} alt="" />
                </div>
                <div className="featured-item" onClick={()=>{
                    _logEvent('click', "Tennis", "IG OnDemand");
                    addFlow("IG OnDemand");
                    navigate("/solutions/ig-on-demand")}}>
                    <div className="item-head">
                        <LogoMini />
                        IG OnDemand
                    </div>
                    <img src={OnDemand} alt="" />
                </div>
                <div className="featured-item" onClick={()=>{
                    _logEvent('click', "Tennis", "IG Quick Pay");
                    addFlow("IG Quick Pay");
                    navigate("/solutions/ig-quick-pay")}}>
                    <div className="item-head">
                        <LogoMini />
                        IG Quick Pay
                    </div>
                    <img src={QuickPay} alt="" />
                </div>
                <div className="featured-item" onClick={()=>{
                    _logEvent('click', "Tennis", "Book4Time");
                    addFlow("Book4Time");
                    navigate("/solutions/book4time")}}>
                    <div className="item-head">
                        <LogoMini />
                        Book4Time
                    </div>
                    <img className="book4time" src={Book4Time} alt="" />
                </div>
                <div className="featured-item" onClick={()=>{
                    _logEvent('click', "Tennis", "Reserve");
                    addFlow("Reserve");
                    navigate("/solutions/reserve")}}>
                    <div className="item-head">
                        <LogoMini />
                        Reserve
                    </div>
                    <img src={Reserve} alt="" />
                </div>     
            </FeaturedSolutions>
        </div>
    )
}

export default TennisPage;